module.exports = __webpack_public_path__ + "static/img/Telefonica.1c856a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Telefonica.jpg
// module id = Hykl
// module chunks = 0